module.exports = __webpack_public_path__ + "media/images/icons/vendors/caterers-86e64c9afa24526483baf285a85c6564.png";